import { render, staticRenderFns } from "./footer-menu.vue?vue&type=template&id=d9d9f3de&scoped=true"
import script from "./footer-menu.vue?vue&type=script&lang=js"
export * from "./footer-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d9f3de",
  null
  
)

export default component.exports